import { Col, Pagination, Row, Select, Spin } from "antd"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import LayoutCommon from "src/components/Common/Layout"
import FlInput from "src/components/FloatingLabel/Input"
import FlSelect from "src/components/FloatingLabel/Select"
import FlTreeSelect from "src/components/FloatingLabel/TreeSelect"
import { SYSTEM_KEY } from "src/constants/constants"
import { getListComboByKey } from "src/lib/utils"
import CourseItem from "src/pages/ANONYMOUS/Home/component/ListCourse/CourseItem"
import GuestServices from "src/services/GuestService"
import { ListCourseStyle } from "../ListCourse/styled"

const SearchCourse = ({ props }) => {
  const { state } = useLocation()
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState()
  const [listTopic, setListTopic] = useState([])
  const [pagination, setPagination] = useState({
    PageSize: 12,
    CurrentPage: 1,
    TextSearch: state?.textSearch,
    CoursePrice: 0,
    TopicID: 0,
  })
  const { listSystemKey } = useSelector(state => state.appGlobal)

  useEffect(() => {
    getCourses()
  }, [pagination])

  const getCourses = async () => {
    const body = {
      ...pagination,
      // TextSearch: state?.textSearch
    }

    const res = await GuestServices.getAllCourse(body)
    if (res?.isError) return
    setDataSource(res.Object)
  }

  const nest = (items, id, link) =>
    items
      ?.filter(item => item[link] === id)
      .map(item => ({
        ...item,
        title: item.TopicName,
        key: item.TopicID,
        value: item.TopicID,
        children: nest(items, item?.TopicID, link),
      }))
  useEffect(() => {
    GuestServices.getAllTopicByCourse()
      .then(res => {
        if (res.isError) return

        setListTopic([
          {
            title: "tất cả",
            value: 0,
          },
          ...nest(res?.Object?.lstTopicVM, 0, "ParentID"),
        ])
      })
      .finally(() => {})
  }, [])

  const onchangePagination = current => {
    setPagination({
      ...pagination,
      CurrentPage: current,
    })
  }

  const search = value => {
    setPagination(pre => ({
      ...pre,
      TextSearch: value,
    }))
  }
  const filterPrice = value => {
    setPagination(pre => ({
      ...pre,
      CoursePrice: value,
    }))
  }
  const filterTopic = value => {
    setPagination(pre => ({
      ...pre,
      TopicID: value,
    }))
  }

  return (
    <Spin spinning={loading}>
      <LayoutCommon>
        <Row className="mt-20 bg-" gutter={20}>
          <Col xs={24} md={12}>
            <FlInput
              search
              onSearch={search}
              defaultValueInput={state?.textSearch}
            />
          </Col>
          <Col xs={12} md={6}>
            <FlSelect label="xắp xếp" onChange={filterPrice}>
              {getListComboByKey(
                SYSTEM_KEY?.COURSE_PRICE_TYPE,
                listSystemKey,
              )?.map(i => (
                <Select.Option key={+i.CodeValue} value={+i.CodeValue}>
                  {i?.Description}
                </Select.Option>
              ))}
            </FlSelect>
          </Col>
          <Col xs={12} md={6}>
            <FlTreeSelect
              label="Chọn chủ để"
              onChange={filterTopic}
              style={{ width: "100%" }}
              treeDefaultExpandAll={true}
              showSearch
              treeNodeFilterProp="title"
              treeData={listTopic}
            />
          </Col>
        </Row>
        <div className="mt-30">
          <span className="fs-19 fw-600">
            {dataSource?.total > 0
              ? `Tìm thấy  ${dataSource?.total} khóa học`
              : "Không tìm thấy khóa học nào"}
          </span>
        </div>
        <ListCourseStyle>
          <Row gutter={[16, 16]}>
            {!!dataSource?.lstCourseVM?.length &&
              dataSource.lstCourseVM.map(item => (
                <CourseItem item={item} key={item} />
              ))}
          </Row>
        </ListCourseStyle>
        <div
          style={{
            display: "flex",
            flexDirection: "row-reverse",
            marginBottom: "23px",
            marginTop: "10px",
          }}
        >
          {dataSource?.total > 0 && (
            <Pagination
              current={pagination.CurrentPage}
              defaultPageSize={pagination.PageSize}
              total={dataSource?.total}
              onChange={onchangePagination}
            />
          )}
        </div>
      </LayoutCommon>
    </Spin>
  )
}

export default SearchCourse
